import AssessmentOutlined from '@mui/icons-material/AssessmentOutlined';
import ChatOutlined from '@mui/icons-material/ChatOutlined';

import { Flex } from '../utils';

import { LobbyCard } from './LobbyCard';

import * as events from '@/utils/eventTracker';
import { useTranslate } from '@/hooks';

export const ReportsLobby = () => {
  const { t } = useTranslate('lobbys');

  return (
    <Flex gap="1rem" p="25px" id="lobby-container-reports">
      <LobbyCard
        title={t('reports.reportsChatbot')}
        description={t('reports.reportsChatbot')}
        to="/reports/reports-chatbot"
        onClick={events.goToChatbotMetrics}
        icon={<ChatOutlined />}
        cta={t('seeMore')}
      />
      <LobbyCard
        title={t('reports.AIReports')}
        description={t('reports.AIReports')}
        onClick={events.goToAiReports}
        to="/reports/reports-ai"
        icon={<AssessmentOutlined />}
        cta={t('seeMore')}
      />
    </Flex>
  );
};
